import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NodePoint } from '../../types/types'


function simplifyNodePointMock(point: any): NodePoint {
  return {
    id: point.id,
    lat: Number(point.lat),
    lon: Number(point.lon),
    title: point.title,
    text: point.text,
    url: point.url,
    description: point.description

  };
}

interface GetApiNodePointsState {
  loading: boolean;
  loadingError: boolean;
  nodePoints: NodePoint[] | null;
}

const initialState: GetApiNodePointsState = {
  loading: false,
  loadingError: false,
  nodePoints: null,
};

const getApiNodePointsSlice = createSlice({
  name: 'getApiNodePoints',
  initialState,
  reducers: {
    fetchGetNodePoints(state: GetApiNodePointsState, action: PayloadAction<{}>) {
      state.loading = true;
      state.loadingError = false;
    },
    fetchGetNodePointsSuccess(state: GetApiNodePointsState, action: any) {
      state.nodePoints = action.payload.map(simplifyNodePointMock);
      state.loading = false;
    },
    fetchGetNodePointsFailed(state: GetApiNodePointsState) {
      state.loading = false;
      state.loadingError = true;
    },
  },
});

// Actions
export const apiNodePointsActions = getApiNodePointsSlice.actions;
// Selectors
export const nodePointsLoading = (state: { getApiNodePoints: GetApiNodePointsState }): boolean => state.getApiNodePoints.loading;
export const nodePointsLoadingError = (state: { getApiNodePoints: GetApiNodePointsState }): boolean => state.getApiNodePoints.loadingError;
export const nodePoints = (state: { getApiNodePoints: GetApiNodePointsState }): NodePoint[] | null => state.getApiNodePoints.nodePoints;

// Reducers
const getApiNodePointsReducer = getApiNodePointsSlice.reducer;
export default getApiNodePointsReducer;
